import { render, staticRenderFns } from "./Fireworks.vue?vue&type=template&id=2a71ef9a"
import script from "./Fireworks.vue?vue&type=script&lang=js"
export * from "./Fireworks.vue?vue&type=script&lang=js"
import style0 from "./Fireworks.vue?vue&type=style&index=0&id=2a71ef9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports